module.exports = "data:application/octet-stream;base64,UkVBQ1RfQVBQX0dJVEhVQl9DTElFTlRfSUQ9JzEyMzdiOGM1MDc5MjFjZjkyMzJkJwpSRUFDVF9BUFBfR0lUSFVCX0NMSUVOVF9TRUNSRVQ9J2Y5NzdkMjQ3MDkyMGVlMjE0NDg4NWUwNjJjZjc5NWU5NDdmMjRlNmYn"


//////////////////
// WEBPACK FOOTER
// ./.env.local
// module id = 85
// module chunks = 0